export const enum endpoints {
  register = "/auth-user/signup",
  verifyEmail = "/auth-user/verify-otp",
  resendOtp = "/auth-user/resend-otp",
  login = "/auth-user/login",
  forgotPassword = "/auth-user/forgot-password",
  resetPassword = "/auth-user/reset-password",
  updatePassword = "/auth-user/update-password",
  profile = "/profile",

  user = "/user",
  contact = "/contact",

  addresses = "/user/addresses",

  products = "/products",
  brand = "/products/brands",


  cartCount = "/cart/count",
  cart = "/cart",

  order = "/order",
  returns = "/returns",
  rating = "/user/ratings"

}
